import LoginImg from "@/assets/images/loginScreen.png";
import Logo1 from "@/assets/images/neotasLogo.png";

export {LoginImg, Logo1};
